<template>
  <USlideover side="top" title="Search">
    <slot>
        <UButton label="Open" color="neutral" variant="subtle" />
    </slot>

    <template #header>
         <UContainer>
            <UInput
              v-model="query"
              placeholder="Search"
              size="xl"
              icon="i-heroicons-magnifying-glass"
              class="w-full"
              @keydown.escape="handleEscape"
            >
              <template v-if="query.length" #trailing>
                <UButton
                  color="neutral"
                  variant="link"
                  size="md"
                  icon="i-lucide-circle-x"
                  aria-label="Clear input"
                  @click="query = ''"
                />
              </template>
            </UInput>
         </UContainer>
    </template>

    <template #body>
        <UContainer>
          <div v-if="!query" class="py-8 text-center">
            <p class="text-gray-500">Type to search for products.</p>
          </div>
          <div v-else>
            <div v-if="pending" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <TinyProductCardSkeleton  />
            </div>
            <div v-else-if="error" class="py-8">
              <UAlert
                title="Search Error"
                description="Unable to search products. Please try again."
                icon="i-lucide-alert-circle"
                color="error"
                variant="soft"
              />
            </div>
            <div v-else>
              <p v-if="!products.length" class="text-gray-500 py-8 text-center">No products found.</p>
              <div v-else class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
                <TinyProductCard 
                  v-for="product in products" 
                  :key="product.id" 
                  :product="product"
                  class="border border-gray-200 rounded-lg hover:bg-gray-50 dark:border-gray-700 dark:hover:bg-gray-800"
                />
              </div>
            </div>
          </div>
        </UContainer>   
    </template>
  </USlideover>
</template>
<script setup lang="ts">
import TinyProductCard from '~/components/molecules/TinyProductCard.vue'
import TinyProductCardSkeleton from '~/components/molecules/TinyProductCardSkeleton.vue'

const { query, products, pending, error } = useProductSearch({
  perPage: 12
})

function handleEscape() {
  query.value = '';
}
</script>